/**
 * Link Resolver for Prismic documents
 * This resolver determines the URL path for each document type in your Prismic repository
 * Used by both gatsby-source-prismic and gatsby-plugin-prismic-previews
 */
const linkResolver = doc => {
  if (!doc) {
    return "/"
  }

  // Get category from doc.data if available
  const category = doc.data?.category || 'devops'

  switch (doc.type) {
    case "home":
      return "/"
    case "technologies_page":
      return "/technologies"
    case "consulting_page":
      return "/services/devops/" // Redirect old consulting page to services
    case "single_technologies_page":
      return `/technologies/${doc.uid}/`
    case "services":
      return "/services/devops/" // Default services hub
    case "services_page":
      return `/services/${category}/${doc.uid}/`
    case "consulting":
      return `/services/${category}/${doc.uid}/`
    case "blog":
      return "/blog"
    case "blog_post":
      return `/blog/${doc.uid}/`
    case "case_studies":
      return "/case-studies"
    case "case_studies_post":
      return `/case-studies/${doc.uid}/`
    case "pdf_marketing_pages":
      return `/${doc.uid}/`
    case "author":
      return `/blog/authors/${doc.uid}/`
    case "authors":
      return "/blog/authors"
    case "privacy_policy":
      return "/privacy-policy"
    case "terms_of_use_page":
      return "/terms-of-use"
    case "reviews":
      return "/reviews"
    case "careers":
      return "/careers"
    case "about":
      return "/about"
    default:
      if (!doc.uid) return "/"
      return `/${doc.uid}/`
  }
}

module.exports = linkResolver
module.exports.linkResolver = linkResolver
